// 业务管理路由
import Layout from "@/layout";

const businessRoute = [
  {
    path: "/business-management",
    component: Layout,
    redirect: "/business-management/list",
    name: "business-management",
    alwaysShow: true, // will always show the root menu
    meta: {
      title: "业务管理",
      icon: "check-result",
      roles: ["ROLE_STAFF"]
    },
    children: [
      {
        path: "online-order",
        component: () => import("@/views/businessManagement/onlineOrder"),
        name: "onlineOrder",
        meta: {
          title: "委托下单",
          icon: "check-result",
        },
      },
      {
        path: "test-center",
        component: () => import("@/views/taskCenter/testCenter/index"),
        name: "testCenter",
        meta: {
          title: "委托处理",
          icon: "check-result",
        },
      },
      {
        path: "accept-order/:id",
        component: () => import("@/views/businessManagement/acceptOrder"),
        name: "AcceptOrder",
        meta: {
          title: "委托单受理",
          icon: "check-result",
        },
        hidden:true
      },
      {
        path: "order-approval/:id",
        component: () => import("@/views/businessManagement/acceptOrder"),
        name: "order-approval",
        meta: {
          title: "委托单审核",
          icon: "check-result",
        },
        hidden:true
      },
      {
        path: "view-enstrust-order/:id",
        component: () => import("@/views/businessManagement/acceptOrder"),
        name: "view-enstrust-order",
        meta: {
          title: "查看委托单",
          icon: "check-result",
        },
        hidden:true
      },
      {
        path: "payment",
        component: () => import("@/views/businessManagement/payment"),
        name: "payment",
        meta: {
          title: "支付订单",
          icon: "check-result",
          noCache:true
        },
        hidden:true
      },
      {
        path: "update-online-order",
        component: () => import("@/views/businessManagement/acceptOrder"),
        name: "updateOnlineOrder",
        meta: {
          title: "修改订单",
          icon: "check-result",
        },
        hidden:true
      },
      {
        path: "issued-task/:id",
        component: () => import("@/views/taskCenter/testCenter/issuedTask"),
        name: "issuedTask",
        meta: {
          title: "任务下达",
          icon: "check-result",
          noCache:true
        },
        hidden:true
      }
    ]
  }
]
export default  businessRoute



// WEBPACK FOOTER //
// ./src/router/modules/business.js